import React from 'react';
//Styling
import './style.scss';

export default function Footer() {
  return (
    <div className="footer-ctr">
      <h1>Ada pertanyaan?</h1>
      <a rel="noopener noreferrer" href="https://linktr.ee/support_goldismia" target="_blank">
        <button className="contact-us-btn" type="button">
          Hubungi Kami
        </button>
      </a>
      <p>© Copyright GOLD-ISMIA 2021. All Rights Reserved.</p>
    </div>
  );
}
